<template>
  <div>
    <!-- 页面头部 -->
    <page-header>
      <div>代理商管理</div>
    </page-header>

    <!-- 搜索和操作区域 -->
    <div class="operation-area">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input
              v-model="searchKeyword"
              placeholder="请输入代理商名称、用户名或手机号"
              clearable
              @keyup.enter="handleSearch"
              @clear="handleSearch"
          >
            <template #prefix>
              <i class="el-icon-search"></i>
            </template>
          </el-input>
        </el-col>
        <el-col :span="16" class="text-right">
          <el-button type="primary" @click="handleAdd">
            <i class="el-icon-plus"></i>
            新增代理商
          </el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 统计卡片 -->
    <div class="stat-cards">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="stat-card">
            <div class="stat-icon"><i class="el-icon-user"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.total || 0 }}</div>
              <div class="stat-label">代理商总数</div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat-card">
            <div class="stat-icon"><i class="el-icon-shop"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.merchantCount || 0 }}</div>
              <div class="stat-label">管理店铺数</div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="stat-card">
            <div class="stat-icon"><i class="el-icon-money"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.totalCommission || 0 }}</div>
              <div class="stat-label">累计佣金(元)</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 表格 -->
    <table-union-pager
        :data="tableData"
        @current-change="handlePageChange"
    >
      <el-table-column label="ID" prop="id" width="80" align="center"/>
      <el-table-column label="代理商名称" prop="name" min-width="120"/>
      <el-table-column label="用户名" prop="username" min-width="120"/>
      <el-table-column label="手机号" prop="phone" min-width="120"/>
      <el-table-column label="管理店铺数" min-width="100" align="center">
        <template #default="scope">
          <el-button type="text" @click="viewMerchants(scope.row)">
            {{ scope.row.merchantCount || 0 }} 家
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="佣金比例" min-width="100" align="center">
        <template #default="scope">
          {{ scope.row.commissionRatio || 0 }}%
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.valid ? 'success' : 'danger'" size="small">
            {{ scope.row.valid ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="160">
        <template #default="scope">
          {{ formatTime(scope.row.addDataTime) }}
        </template>
      </el-table-column>
      <el-table-column label="最后登录" width="160">
        <template #default="scope">
          {{ formatTime(scope.row.lastLoginTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" fixed="right" align="center">
        <template #default="scope">
          <div class="text-buttons">
            <span class="btn-text btn-edit" @click="handleEdit(scope.row)">
              <i class="el-icon-edit"></i>编辑
            </span>
            <span class="btn-text btn-setting" @click="setCommission(scope.row)">
              <i class="el-icon-s-operation"></i>佣金设置
            </span>
            <span class="btn-text btn-reset" @click="handleResetPassword(scope.row)">
              <i class="el-icon-refresh"></i>重置密码
            </span>
            <span class="btn-text btn-delete" @click="handleDelete(scope.row)">
              <i class="el-icon-delete"></i>删除
            </span>
          </div>
        </template>
      </el-table-column>
    </table-union-pager>

    <!-- 新增/编辑代理商弹窗 -->
    <el-dialog
        :visible.sync="dialogVisible"
        :title="dialogTitle"
        width="500px"
        @close="handleDialogClose"
    >
      <el-form
          ref="agentFormRef"
          :model="agentForm"
          :rules="rules"
          label-width="100px"
      >
        <el-form-item label="代理商名称" prop="name" required>
          <el-input v-model="agentForm.name" placeholder="请输入代理商名称" />
        </el-form-item>

        <el-form-item label="用户名" prop="username" required>
          <el-input v-model="agentForm.username" placeholder="请输入登录用户名" />
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="agentForm.phone" placeholder="请输入手机号" />
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="agentForm.email" placeholder="请输入邮箱" />
        </el-form-item>

        <el-form-item v-if="!agentForm.id" label="密码" prop="password" required>
          <el-input
              v-model="agentForm.password"
              type="password"
              placeholder="请输入密码"
              show-password
          />
        </el-form-item>

        <el-form-item v-else label="密码">
          <el-input
              v-model="agentForm.password"
              type="password"
              placeholder="不修改请留空"
              show-password
          />
        </el-form-item>

        <el-form-item label="状态" prop="valid">
          <el-switch
              v-model="agentForm.valid"
              active-text="正常"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 佣金设置弹窗 -->
    <el-dialog
        :visible.sync="commissionDialog.visible"
        title="佣金比例设置"
        width="450px"
        @close="handleCommissionDialogClose"
    >
      <el-form :model="commissionDialog.form" label-width="100px">
        <el-form-item label="代理商名称">
          <span>{{ commissionDialog.form.name }}</span>
        </el-form-item>
        <el-form-item label="佣金比例" required>
          <el-input-number
              v-model="commissionDialog.form.commissionRatio"
              :min="0"
              :max="100"
              :precision="2"
              :step="0.5"
              placeholder="请输入佣金比例"
          />
          <span class="form-tip">%</span>
        </el-form-item>
        <div class="form-tip-text">
          <i class="el-icon-info"></i>
          佣金比例将影响该代理商名下所有店铺的分润
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="commissionDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="handleCommissionSubmit" :loading="commissionDialog.loading">
            保存设置
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 重置密码弹窗 -->
    <el-dialog
        :visible.sync="resetDialogVisible"
        title="重置密码"
        width="400px"
        @close="handleResetDialogClose"
    >
      <el-form
          ref="passwordFormRef"
          :model="passwordForm"
          :rules="passwordRules"
          label-width="100px"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
              v-model="passwordForm.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password
          />
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              placeholder="请确认新密码"
              show-password
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="resetDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleResetSubmit" :loading="submitting">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 管理的店铺列表弹窗 -->
    <el-dialog
        :visible.sync="merchantDialog.visible"
        :title="merchantDialog.title"
        width="800px"
    >
      <el-table :data="merchantDialog.list" border stripe>
        <el-table-column label="店铺ID" prop="id" width="80" />
        <el-table-column label="店铺名称" prop="name" min-width="150" />
        <el-table-column label="联系人" prop="contactPhone" width="120" />
        <el-table-column label="状态" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '正常' : '暂停' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="佣金比例" width="100">
          <template #default="scope">
            {{ scope.row.commissionRatio || 0 }}%
          </template>
        </el-table-column>
        <el-table-column label="添加时间" width="160">
          <template #default="scope">
            {{ formatTime(scope.row.addDataTime) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container" v-if="merchantDialog.total > 0">
        <el-pagination
            @current-change="handleMerchantPageChange"
            :current-page="merchantDialog.page"
            :page-size="merchantDialog.pageSize"
            :total="merchantDialog.total"
            layout="prev, pager, next"
            background
        />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="merchantDialog.visible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import TableUnionPager from "@/components/TableUnionPager";
import PageHeader from "@/components/PageHeader";
import api from "@/utils/api";

export default {
  name: "AgentList",
  components: {
    TableUnionPager,
    PageHeader
  },
  data() {
    // 验证密码确认
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      tableData: {
        list: [],
        totalCount: 0,
        page: 1,
        pageSize: 10
      },
      searchKeyword: '',
      stats: {
        total: 0,
        merchantCount: 0,
        totalCommission: 0
      },
      dialogVisible: false,
      resetDialogVisible: false,
      submitting: false,

      agentForm: {
        id: null,
        name: '',
        username: '',
        phone: '',
        email: '',
        password: '',
        valid: 1
      },

      passwordForm: {
        id: null,
        newPassword: '',
        confirmPassword: ''
      },

      rules: {
        name: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },

      passwordRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },

      // 佣金设置
      commissionDialog: {
        visible: false,
        loading: false,
        form: {
          id: null,
          name: '',
          commissionRatio: 0
        }
      },

      // 店铺列表弹窗
      merchantDialog: {
        visible: false,
        title: '',
        list: [],
        total: 0,
        page: 1,
        pageSize: 10,
        agentId: null
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.agentForm.id ? '编辑代理商' : '新增代理商'
    }
  },
  mounted() {
    this.loadData()
    this.loadStats()
  },
  methods: {
    // 加载数据
    loadData() {
      api.admin_getAgentList({
        page: this.tableData.page,
        pageSize: this.tableData.pageSize,
        search: this.searchKeyword
      }).then(res => {
        console.log('API返回:', res)

        if (res.data && res.data.code === '000') {
          const data = res.data.data
          if (data && data.data) {
            this.tableData.list = data.data.list || []
            this.tableData.totalCount = data.data.totalCount || 0
          } else if (data && data.list) {
            this.tableData.list = data.list || []
            this.tableData.totalCount = data.totalCount || 0
          }
        }
      }).catch(error => {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      })
    },

    // 加载统计数据
    loadStats() {
      api.admin_getAgentStats().then(res => {
        if (res.data && res.data.code === '000' && res.data.data) {
          this.stats = res.data.data
        }
      }).catch(error => {
        console.error('加载统计数据失败:', error)
      })
    },

    // 搜索
    handleSearch() {
      this.tableData.page = 1
      this.loadData()
    },

    // 分页改变
    handlePageChange(page) {
      this.tableData.page = page
      this.loadData()
    },

    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '--'
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 新增
    handleAdd() {
      this.agentForm = {
        id: null,
        name: '',
        username: '',
        phone: '',
        email: '',
        password: '',
        valid: 1
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.agentForm = {
        id: row.id,
        name: row.name,
        username: row.username,
        phone: row.phone || '',
        email: row.email || '',
        password: '',
        valid: row.valid
      }
      this.dialogVisible = true
    },

    // 佣金设置
    setCommission(row) {
      this.commissionDialog.form = {
        id: row.id,
        name: row.name,
        commissionRatio: row.commissionRatio || 0
      }
      this.commissionDialog.visible = true
    },

    // 保存佣金设置
    handleCommissionSubmit() {
      this.commissionDialog.loading = true
      api.admin_updateAgentCommission({
        id: this.commissionDialog.form.id,
        commissionRatio: this.commissionDialog.form.commissionRatio
      }).then(res => {
        this.commissionDialog.loading = false
        if (res.data && res.data.code === '000') {
          this.$message.success('佣金比例设置成功')
          this.commissionDialog.visible = false
          this.loadData()
          this.loadStats()
        } else {
          this.$message.error(res.data?.message || '设置失败')
        }
      }).catch(() => {
        this.commissionDialog.loading = false
        this.$message.error('设置失败')
      })
    },

    // 重置密码
    handleResetPassword(row) {
      this.passwordForm = {
        id: row.id,
        newPassword: '',
        confirmPassword: ''
      }
      this.resetDialogVisible = true
    },

    // 重置密码提交
    handleResetSubmit() {
      this.$refs.passwordFormRef.validate(valid => {
        if (valid) {
          this.submitting = true
          api.admin_resetPassword({
            id: this.passwordForm.id,
            newPassword: this.passwordForm.newPassword
          }).then(res => {
            this.submitting = false
            if (res.data && res.data.code === '000') {
              this.$message.success('密码重置成功')
              this.resetDialogVisible = false
            } else {
              this.$message.error(res.data?.message || '操作失败')
            }
          }).catch(() => {
            this.submitting = false
            this.$message.error('操作失败')
          })
        }
      })
    },

    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除代理商 "${row.name}" 吗？删除后不可恢复！`, '提示', {
        type: 'warning',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        api.admin_delete({ id: row.id }).then(res => {
          if (res.data && res.data.code === '000') {
            this.$message.success('删除成功')
            this.loadData()
            this.loadStats()
          } else {
            this.$message.error(res.data?.message || '删除失败')
          }
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },

    // 查看管理的店铺
    viewMerchants(row) {
      this.merchantDialog.title = `${row.name} 管理的店铺`
      this.merchantDialog.agentId = row.id
      this.merchantDialog.page = 1
      this.merchantDialog.visible = true
      this.loadAgentMerchants()
    },

    // 加载代理商管理的店铺
    loadAgentMerchants() {
      api.agentMerchant_getMerchantsByAgent({
        agentId: this.merchantDialog.agentId,
        page: this.merchantDialog.page,
        pageSize: this.merchantDialog.pageSize
      }).then(res => {
        if (res.data && res.data.code === '000' && res.data.data) {
          const data = res.data.data
          this.merchantDialog.list = data.list || []
          this.merchantDialog.total = data.total || 0
        }
      }).catch(error => {
        console.error('加载店铺列表失败:', error)
      })
    },

    // 店铺列表分页
    handleMerchantPageChange(page) {
      this.merchantDialog.page = page
      this.loadAgentMerchants()
    },

    // 提交表单
    handleSubmit() {
      this.$refs.agentFormRef.validate(valid => {
        if (valid) {
          this.submitting = true
          const data = { ...this.agentForm }

          // 设置账号类型为代理(2)
          data.accountType = 2

          // 编辑时如果没有修改密码，删除密码字段
          if (data.id && !data.password) {
            delete data.password
          }

          api.admin_addOrUpdate(data).then(res => {
            this.submitting = false
            if (res.data && res.data.code === '000') {
              this.$message.success(data.id ? '修改成功' : '新增成功')
              this.dialogVisible = false
              this.loadData()
              this.loadStats()
            } else {
              this.$message.error(res.data?.message || '操作失败')
            }
          }).catch(() => {
            this.submitting = false
            this.$message.error('操作失败')
          })
        }
      })
    },

    // 对话框关闭时重置表单
    handleDialogClose() {
      this.$refs.agentFormRef?.resetFields()
    },

    // 重置密码对话框关闭时重置表单
    handleResetDialogClose() {
      this.$refs.passwordFormRef?.resetFields()
    },

    // 佣金设置弹窗关闭
    handleCommissionDialogClose() {
      this.commissionDialog.form = {
        id: null,
        name: '',
        commissionRatio: 0
      }
    }
  }
}
</script>

<style scoped>
.operation-area {
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.text-right {
  text-align: right;
}

.stat-cards {
  margin-bottom: 20px;
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  display: flex;
  align-items: center;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: #ecf5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.stat-icon i {
  font-size: 28px;
  color: #409eff;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}

.text-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-text {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
}

.btn-text i {
  margin-right: 4px;
}

.btn-edit {
  color: #409EFF;
}
.btn-edit:hover {
  background-color: rgba(64, 158, 255, 0.1);
}

.btn-setting {
  color: #E6A23C;
}
.btn-setting:hover {
  background-color: rgba(230, 162, 60, 0.1);
}

.btn-reset {
  color: #909399;
}
.btn-reset:hover {
  background-color: rgba(144, 147, 153, 0.1);
}

.btn-delete {
  color: #F56C6C;
}
.btn-delete:hover {
  background-color: rgba(245, 108, 108, 0.1);
}

.dialog-footer {
  text-align: right;
}

.form-tip {
  margin-left: 8px;
  color: #909399;
}

.form-tip-text {
  font-size: 12px;
  color: #909399;
  padding: 8px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  margin-top: 12px;
}

.form-tip-text i {
  margin-right: 4px;
}

.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>

<style>
/* 弹窗层级修复 */
.el-dialog__wrapper {
  z-index: 2000 !important;
}
.v-modal {
  z-index: 1999 !important;
}
.el-dialog {
  z-index: 2001 !important;
}
.el-select-dropdown {
  z-index: 2100 !important;
}
</style>